import BaseModel from "../../../common/model/base_model";

export default class CountryModel extends BaseModel {

    id = null;
    name = '';
    vat_rate = 0;
    vat_conditional = false;

}